<script setup>
defineProps({
  videoObj: {
    type: Object,
    required: true,
  },
  videoParams: {
    type: Object,
    required: true,
  },
});
</script>

<template>
  <iframe
    :width="videoParams.width"
    :height="videoParams.height"
    :src="videoObj.url"
    :color="videoParams.color"
    :iv_load_policy="videoParams.loadPolicy"
    :allowfullscreen="videoParams.allowFullScreen"
  />
</template>
